import { apiCall } from './gqlClient';

const GENERATEACCESSPASS_QUERY = `
  query generateAccessPass($providerId: Int!) {
    generateAccessPass(providerId: $providerId)
    {
      userId
			providerId
			timestamp
			nonce
			signature
      ...fragments
    }
  }`;

export const generateAccessPassApiCall = async ({providerId}, fragments = null) => apiCall({ query: GENERATEACCESSPASS_QUERY, variables: {providerId}, fragments });

const GETALLGYMACCESSEVENTS_QUERY = `
  query getAllGymAccessEvents {
    getAllGymAccessEvents
    {
      id
			userId
			providerId
			eventType
			enteredAt
			leftAt
      ...fragments
    }
  }`;

export const getAllGymAccessEventsApiCall = async (fragments = null) => apiCall({ query: GETALLGYMACCESSEVENTS_QUERY, variables: {}, fragments });

const GETPROVIDERGYMACCESSRULES_QUERY = `
  query getProviderGymAccessRules {
    getProviderGymAccessRules
    {
      id
			providerId
			qrEnabled
			requireSub
			membershipId
			qrTtlSeconds
      ...fragments
    }
  }`;

export const getProviderGymAccessRulesApiCall = async (fragments = null) => apiCall({ query: GETPROVIDERGYMACCESSRULES_QUERY, variables: {}, fragments });

const SCANACCESSPASS_QUERY = `
  mutation scanAccessPass($payload: AccessPassInput!) {
    scanAccessPass(payload: $payload)
    {
      id
			userId
			providerId
			eventType
			enteredAt
			leftAt
      ...fragments
    }
  }`;

export const scanAccessPassApiCall = async ({payload}, fragments = null) => apiCall({ query: SCANACCESSPASS_QUERY, variables: {payload}, fragments });

const SAVEPROVIDERGYMACCESSRULES_QUERY = `
  mutation saveProviderGymAccessRules($rules: ProviderGymAccessRulesInput!) {
    saveProviderGymAccessRules(rules: $rules)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const saveProviderGymAccessRulesApiCall = async ({rules}, fragments = null) => apiCall({ query: SAVEPROVIDERGYMACCESSRULES_QUERY, variables: {rules}, fragments });
